import React from 'react';
import { CardContext } from '../../../hoc/withCards';
import CurricularEquivalenceCard from './CurricularEquivalenceCard';
const CurricularEquivalenceList = ({ renderLoading }) => {
  return (
    <CardContext.Consumer>
      {({ cards }) => (
        <>
          <div className="card-deck">
            {renderLoading() ||
              cards.map((card) => (
                <CurricularEquivalenceCard
                  key={card.id}
                  id={card.id}
                  card={card}
                />
              ))}
          </div>
        </>
      )}
    </CardContext.Consumer>
  );
};

export default CurricularEquivalenceList;
